import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue/es'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import './styles/index.scss'

import 'amfe-flexible'

Vue.use(Antd)

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
